module.exports = __webpack_public_path__ + "img/86.331d8dfb.jpg";